import * as Sentry from '@sentry/react';
import { isTrackingEnabled, isDiagnosticsEnabled } from '../utils/cookieConsent';

let initialized = false;
let queue = Promise.resolve();

async function synchronize() {
  if (!isTrackingEnabled()) {
    document.getElementById('goodvale-analytics')?.remove();
  }
  if (!isDiagnosticsEnabled()) {
    if (initialized) {
      await Sentry.close();
      initialized = false;
    }
  }
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (dsn && isDiagnosticsEnabled() && !initialized) {
    Sentry.init({
      dsn,
      sendDefaultPii: false,
      beforeSend: event => isDiagnosticsEnabled() ? event : null,
      beforeSendTransaction: event => isDiagnosticsEnabled() ? event : null,
    });
    initialized = true;
  }
  const source = import.meta.env.VITE_UMAMI_SCRIPT_URL;
  const website = import.meta.env.VITE_UMAMI_WEBSITE_ID;
  if (isTrackingEnabled() && source && website && !document.getElementById('goodvale-analytics')) {
    const script = document.createElement('script');
    script.id = 'goodvale-analytics';
    script.src = source;
    script.defer = true;
    script.dataset.websiteId = website;
    document.head.append(script);
  }
}

export function initTelemetry() {
  const update = () => { queue = queue.then(synchronize).catch(() => {}); };
  window.addEventListener('tracking-consent-changed', update);
  window.addEventListener('storage', update);
  update();
}
